var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.25C25 4.45507 23.5449 3 21.75 3H6.25C4.45507 3 3 4.45507 3 6.25V21.75C3 23.5449 4.45507 25 6.25 25H12.2483C12.2483 25 12.25 24.5184 12.25 24.25V23.5H6.25C5.2835 23.5 4.5 22.7165 4.5 21.75V9.503H23.5V21.75C23.5 22.7165 22.7165 23.5 21.75 23.5H15.75V24.25C15.75 24.5184 15.75 25 15.75 25H21.75C23.5449 25 25 23.5449 25 21.75V6.25ZM6.25 4.5H21.75C22.7165 4.5 23.5 5.2835 23.5 6.25V8.003H4.5V6.25C4.5 5.2835 5.2835 4.5 6.25 4.5Z",
    fill: "var(--icon-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13.25C15.25 13.9404 14.6904 14.5 14 14.5C13.3096 14.5 12.75 13.9404 12.75 13.25C12.75 12.5596 13.3096 12 14 12C14.6904 12 15.25 12.5596 15.25 13.25Z",
    fill: "var(--icon-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7517 20.3105C16.0613 20.5857 16.5354 20.5579 16.8105 20.2483C17.0857 19.9387 17.0579 19.4646 16.7483 19.1894L14.4983 17.1894C14.2141 16.9368 13.7859 16.9368 13.5017 17.1894L11.2517 19.1894C10.9421 19.4646 10.9142 19.9387 11.1894 20.2483C11.4646 20.5579 11.9387 20.5857 12.2483 20.3105L13.25 19.4201V25.25C13.25 25.6642 13.5858 26 14 26C14.4142 26 14.75 25.6642 14.75 25.25V19.4201L15.7517 20.3105Z",
    fill: "var(--icon-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar-today.58da92cdba8cb039eae3a75deba2f281.svg";
export { ForwardRef as ReactComponent };